import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";

import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export interface DatePickerComponentProps {
  label?: string;
  required?: boolean;
  containerClass?: string;
  containerStyle?: React.CSSProperties;
  onChange?: (date: Date | null) => void;
  date?: Date | null;
  placeholder?: string;
  timeIntervals?: number;
  showTimeSelect?: boolean;
  dateFormat?: string;
  [key: string]: any;
}

export default function DatePickerComponent({
  label = "",
  required = false,
  containerClass,
  containerStyle = {},
  onChange = () => {},
  date = new Date(),
  placeholder,
  timeIntervals = 30,
  showTimeSelect = false,
  dateFormat = "dd/MM/yyyy",
  ...rest
}: DatePickerComponentProps) {
  return (
    <FormGroup style={containerStyle} className={containerClass}>
      {label && (
        <Label>
          {label}
          {required && <span style={{ color: "red", marginLeft: 2 }}> *</span>}
        </Label>
      )}
      <InputGroup style={{ flexWrap: "nowrap" }}>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <FontAwesomeIcon icon={["far", "calendar-alt"]} />
          </InputGroupText>
        </InputGroupAddon>
        <DatePicker
          className="form-control"
          placeholderText={placeholder}
          required={true}
          selected={date}
          value={date as any}
          timeIntervals={timeIntervals}
          onChange={(date) => onChange(date)}
          dateFormat={dateFormat}
          showTimeSelect={showTimeSelect}
          {...rest}
        />
      </InputGroup>
    </FormGroup>
  );
}
